import tripPlanService from "@/store/modules/trip-plan/service";
import { defaultVehicleSettings } from '@/store/modules/truck'

export function routeV8Info(params, stopData) {
    let stopPoit = stopData ? stopData : []
    let calculateHowManyInches = new tripPlanService().calculateHowManyInches
    return {
        length: calculateHowManyInches(defaultVehicleSettings.lengthFt, defaultVehicleSettings.lengthIn),
        width: calculateHowManyInches(defaultVehicleSettings.widthFt, defaultVehicleSettings.widthIn),
        height: calculateHowManyInches(defaultVehicleSettings.heightFt, defaultVehicleSettings.heightIn),
        limitedWeight: defaultVehicleSettings.grossWeight,
        weightPerAxle: 0,
        axleCount: defaultVehicleSettings.axles,
        trailersCount: defaultVehicleSettings.trailers,
        shippedHazardousGoods: '',
        routeSetting: ['harshTurn', 'unpaved'], // 路由选项
        alternatives: 1, // 备择方案
        mode: 'truck', // 路由模式，只能是truck
        routeDescription: `${localStorage.getItem('userId')}_${new Date().getTime()}`,// userId_时间戳(毫秒)，用于统计
        departure: new Date().getTime(), // 开始时间，moment.js支持的格式
        wayPoints: [
            {
                latitude: params.loadInfo.pickupLat,
                longitude: params.loadInfo.pickupLon,
                pointType: 'address', // 
                dwellTime: 0, // 停留时间，单位秒
                addressName: '',
                id: '' // poi和facility类型的需要提供id
            },
            ...stopPoit,
            {
                latitude: params.loadInfo.deliveryLat,
                longitude: params.loadInfo.deliveryLon,
                pointType: 'address', // 
                dwellTime: 0, // 停留时间，单位秒
                addressName: '',
                id: '' // poi和facility类型的需要提供id
            }
        ]
    }
}